﻿import { onEvent } from "./_dom";
import { setCookie } from "./cookie";

function init(context) {
	onEvent(context, "a.v3-switch-v2", "click", e => {
		e.preventDefault();
		setCookie("v3", "0", { maxAge: 3E8, path: location.pathname.replace(/^(.*\/db\/[-\d]+)\/.*/i, "$1"), secure: "auto" });
		location.reload(true);
	});
}

export { init };
